/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Days_LeadInputs */

const en_for_whom_days_lead = /** @type {(inputs: For_Whom_Days_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone works differently.`)
};

const pl_for_whom_days_lead = /** @type {(inputs: For_Whom_Days_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy pracuje inaczej.`)
};

/**
* | output |
* | --- |
* | "Everyone works differently." |
*
* @param {For_Whom_Days_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_days_lead = /** @type {((inputs?: For_Whom_Days_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Days_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_days_lead(inputs)
	return en_for_whom_days_lead(inputs)
});